import styled from 'styled-components';

export const LivenessContainer = styled.div`
    max-width: 900px;
    width: 100%;
    min-height: 564px;
    border-radius: 16px;
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;

    ${(props) => props.theme.breakpointTo.xs} {
        min-height: 490px;
    }

    img {
        display: block;
        max-width: 245px;
        max-height: 340px;
        width: 100%;
        height: 100%;
    }

    .icon {
        width: 150px;
        height: 150px;
    }

    .button-leveness {
        &-capitalize {
            text-transform: capitalize;
        }
    }

    .liveness-card {
        width: 100%;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        width: 100%;
        gap: 16px;

        ${(props) => props.theme.breakpointTo.sm} {
            position: sticky;
            bottom: 24px;
            flex-direction: column;
            gap: 12px;
            margin-top: auto;
        }

        .button {
            width: calc(50% - 8px);
            ${(props) => props.theme.breakpointTo.sm} {
                width: 100%;
            }
        }

        .retake-icon {
            width: 16px;
            height: 16px;
            transform: scale(1.5);
        }

        .full-width-button {
            width: 100%;
        }

        .secondary {
            background-color: ${(props) => props.theme.palette.primaryA7};

            ${(props) => props.theme.breakpointTo.sm} {
                &:hover {
                    color: ${(props) => props.theme.palette.primaryA1};
                }
            }
        }
    }

    .requirements-list {
        gap: 8px;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        ${(props) => props.theme.breakpointTo.sm} {
            gap: 12px;
            grid-template-columns: 1fr 1fr;
        }
    }

    .liveness-process-container {
        margin-top: 16px;
    }
`;
